import type { ReactNode } from "react";

import CategoriesSection from "./sections/CategoriesSection";
import FxSection from "./sections/FxSection";
import GeneralSection from "./sections/GeneralSection";

// ---------------------------------------------------------------------------
// Navegación de la app «Configuración» de Finanzas internas (#1255). Alimenta
// el sub-menú (FinanceSettingsLayout) y las rutas (routes.tsx).
// ---------------------------------------------------------------------------

export interface FinanceSettingsNavItem {
  id: string;
  labelKey: string;
  icon: string;
  element: ReactNode;
}

export const MENU: FinanceSettingsNavItem[] = [
  { id: "categories", labelKey: "financeSettings.menu.categories", icon: "ri-price-tag-3-line", element: <CategoriesSection /> },
  { id: "exchange-rates", labelKey: "financeSettings.menu.exchangeRates", icon: "ri-exchange-dollar-line", element: <FxSection /> },
  // Ajustes que valen para toda la app de finanzas (hoy, el plazo de pago de las facturas).
  { id: "general", labelKey: "financeSettings.menu.general", icon: "ri-settings-3-line", element: <GeneralSection /> },
];

export const FINANCE_SETTINGS_BASE = "/finance-settings";

export const financeSettingsDefaultRoute = `${FINANCE_SETTINGS_BASE}/${MENU[0].id}`;
